export default __webpack_public_path__ + "static/media/template_0.dcb74b8e.png";